import React from "react"
interface Props {
	label: string
}
const InputLabel: React.FC<Props> = ({ label }) => {
	return <div className="text-sm text-gray-500">{label}</div>
}

export default InputLabel
